import React, { useState } from 'react';

function ModuleTopics({ _id, _contentTypeId, title, body, viewAllLinkText, topics, className, themeClassName }) {

  return (
   <></>
  );
}

export default ModuleTopics;
